import { useState, useCallback } from 'react';
import { d202Api, FD120, FD121 } from '../../../services/d202Api';

export function useD202Lookup() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master + selected detail row */
  const resolveAllNames = useCallback(async (data: Partial<FD120>, detail?: Partial<FD121>) => {
    const entries: [string, string, string][] = [
      ['supplier', 'supplier', data.fd120_12 || ''],
      ['department', 'department', data.fd120_17 || ''],
      ['currency', 'currency', data.fd120_18 || ''],
      ['warehouse', 'warehouse', data.fd120_14 || ''],
      ['entryPerson', 'employee', data.fd120_91 || ''],
    ];
    if (detail) {
      entries.push(
        ['grade', 'grade', detail.fd121_14 || ''],
      );
    }
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        d202Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await d202Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
